import React from 'react';
import { useMotionParams } from '../hooks/useMotionParams';
import { MotionParamTag } from './MotionParamTag';
import styles from './motionParamTagList.module.scss';

export const MotionParamTagList = () => {
    const { tagListMotionParams } = useMotionParams();
    return (
        <div className={styles['container']}>
            {Object.entries(tagListMotionParams).map(([key, value]) => {
                return <MotionParamTag key={key} category={key} option={value} />;
            })}
        </div>
    );
};
